module.exports = __webpack_public_path__ + "static/media/9.84f39cdb.jpg";